export interface FilterState {
  category: number | null
  autoApprovalOnly: boolean
  priceRange: [number | null, number | null]
  businessName: string
  screenSizeRange: [number | null, number | null]
  footTraffic: string[]
  currentPage: number
}

export const getPriceSummary = (
  priceRange: [number | null, number | null],
): string => {
  const isPriceDefault = priceRange[0] == null && priceRange[1] == null

  if (isPriceDefault) {
    return 'Monthly Price'
  }

  if (priceRange[0] != null && priceRange[1] == null) {
    return `Monthly Price >= $${priceRange[0]}`
  } else if (priceRange[0] == null && priceRange[1] != null) {
    return `Monthly Price <= $${priceRange[1]}`
  } else if (priceRange[0] != null && priceRange[1] != null) {
    if (priceRange[0] === priceRange[1]) {
      return `Monthly Price = $${priceRange[0]}`
    } else {
      return `Monthly Price: $${priceRange[0]} - $${priceRange[1]}`
    }
  }

  return 'Monthly Price'
}

export const getScreenSizeSummary = (
  screenSizeRange: [number | null, number | null],
): string => {
  const isScreenDefault =
    screenSizeRange[0] == null && screenSizeRange[1] == null

  if (isScreenDefault) {
    return 'Screen Size'
  }

  if (screenSizeRange[0] != null && screenSizeRange[1] == null) {
    return `Screen Size >= ${screenSizeRange[0]}"`
  } else if (screenSizeRange[0] == null && screenSizeRange[1] != null) {
    return `Screen Size <= ${screenSizeRange[1]}"`
  } else if (screenSizeRange[0] != null && screenSizeRange[1] != null) {
    if (screenSizeRange[0] === screenSizeRange[1]) {
      return `Screen Size = ${screenSizeRange[0]}"`
    } else {
      return `Screen Size: ${screenSizeRange[0]}" - ${screenSizeRange[1]}"`
    }
  }

  return 'Screen Size'
}

export const isPriceDefault = (
  priceRange: [number | null, number | null],
): boolean => {
  return priceRange[0] == null && priceRange[1] == null
}

export const isScreenSizeDefault = (
  screenSizeRange: [number | null, number | null],
): boolean => {
  return screenSizeRange[0] == null && screenSizeRange[1] == null
}

export const getFootTrafficSummary = (footTraffic: string[]): string => {
  if (footTraffic.length === 0) {
    return 'Foot Traffic'
  }

  if (footTraffic.length === 1) {
    return footTraffic[0].charAt(0).toUpperCase() + footTraffic[0].slice(1)
  }

  if (footTraffic.length === 5) {
    return 'Any Foot Traffic'
  }

  return footTraffic
    .map((level) => level.charAt(0).toUpperCase() + level.slice(1))
    .join(', ')
}

export const isFootTrafficDefault = (footTraffic: string[]): boolean => {
  return footTraffic.length === 0
}

export const hasActiveFilters = (filters: FilterState): boolean => {
  return (
    !isPriceDefault(filters.priceRange) ||
    !isScreenSizeDefault(filters.screenSizeRange) ||
    filters.category != null ||
    filters.autoApprovalOnly ||
    filters.footTraffic.length > 0 ||
    filters.businessName.trim().length > 0
  )
}
